/**
 * Admin welfare-management API client.
 * Base: {VUE_APP_BASE_API}admin/welfare/* — the global axios interceptor adds the bearer token.
 * Every function resolves with `response.data`; errors carry `error.response.data` from the API
 * ({ message, data: { issues: [{ path, message }] } } on validation failures).
 */
import axios from "axios";

const base = `${process.env.VUE_APP_BASE_API}admin/welfare`;
const data = (p) => p.then((r) => r.data);

export const welfareApi = {
  overview: () => data(axios.get(`${base}/overview`)),

  catalog: {
    list: () => data(axios.get(`${base}/catalog`)),
    create: (body) => data(axios.post(`${base}/catalog`, body)),
    update: (id, body) => data(axios.put(`${base}/catalog/${encodeURIComponent(id)}`, body)),
    remove: (id, force = false) => data(axios.delete(`${base}/catalog/${encodeURIComponent(id)}`, { params: force ? { force: true } : {} })),
    reorder: (ids) => data(axios.put(`${base}/catalog/reorder`, { ids })),
  },

  rules: {
    list: (params = {}) => data(axios.get(`${base}/rules`, { params })),
    create: (body) => data(axios.post(`${base}/rules`, body)),
    update: (id, body) => data(axios.put(`${base}/rules/${encodeURIComponent(id)}`, body)),
    patch: (id, body) => data(axios.put(`${base}/rules/${encodeURIComponent(id)}/patch`, body)),
    remove: (id) => data(axios.delete(`${base}/rules/${encodeURIComponent(id)}`)),
    reorder: (ids) => data(axios.put(`${base}/rules/reorder`, { ids })),
    setWelfare: (id, welfare_ids) => data(axios.put(`${base}/rules/${encodeURIComponent(id)}/welfare`, { welfare_ids })),
    test: (body) => data(axios.post(`${base}/rules/test`, body)),
  },

  questions: () => data(axios.get(`${base}/questions`)),

  fieldmap: {
    list: () => data(axios.get(`${base}/fieldmap`)),
    update: (question, body) => data(axios.put(`${base}/fieldmap/${encodeURIComponent(question)}`, body)),
  },

  receipt: {
    list: () => data(axios.get(`${base}/receipt-map`)),
    update: (code, body) => data(axios.put(`${base}/receipt-map/${encodeURIComponent(code)}`, body)),
  },

  meta: {
    get: () => data(axios.get(`${base}/meta`)),
    update: (body) => data(axios.put(`${base}/meta`, body)),
  },

  audit: (params = {}) => data(axios.get(`${base}/audit`, { params })),
  exportBundle: () => data(axios.get(`${base}/export`)),
  importBundle: (bundle, mode = "upsert") => data(axios.post(`${base}/import`, { bundle, mode })),
  refreshCache: () => data(axios.post(`${base}/cache/refresh`)),
};

/** human message from an API error (validation issues are joined) */
export function apiErrorMessage(error, fallback = "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง") {
  const d = error && error.response && error.response.data;
  if (!d) return fallback;
  const issues = d.data && Array.isArray(d.data.issues) ? d.data.issues : [];
  if (issues.length) return `${d.message || fallback}\n${issues.map((i) => `• ${i.message}`).join("\n")}`;
  if (d.data && Array.isArray(d.data.rule_ids) && d.data.rule_ids.length) return `${d.message || fallback}\n(${d.data.rule_ids.join(", ")})`;
  return d.message || fallback;
}
